export function formatPrice(price, lang = "es") {
  const n = Number(price || 0);
  const locale = lang === "en" ? "en-IE" : lang === "it" ? "it-IT" : "es-ES";
  return new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", maximumFractionDigits: n % 1 === 0 ? 0 : 2 }).format(n);
}

export function timeAgo(iso, lang = "es") {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
  if (diff < 60) return rtf.format(-Math.floor(diff), "second");
  if (diff < 3600) return rtf.format(-Math.floor(diff / 60), "minute");
  if (diff < 86400) return rtf.format(-Math.floor(diff / 3600), "hour");
  if (diff < 2592000) return rtf.format(-Math.floor(diff / 86400), "day");
  return rtf.format(-Math.floor(diff / 2592000), "month");
}

export function formatDate(iso, lang = "es") {
  if (!iso) return "";
  const locale = lang === "en" ? "en-GB" : lang === "it" ? "it-IT" : "es-ES";
  return new Date(iso).toLocaleDateString(locale, { year: "numeric", month: "long" });
}
